import React, { useEffect, useState } from 'react'
import { Alert, Button, Group, Modal, Stack, TextInput } from '@mantine/core'
import { toast } from '../services/utils/toast'

const SegmentOptionModal = ({ show, onClose, onAdd, segment }) => {
	const [name, setName] = useState('')
	const [saving, setSaving] = useState(false)
	const [error, setError] = useState('')

	useEffect(() => {
		setName(segment?.name || '')
		setError('')
		setSaving(false)
	}, [segment, show])

	const handleSubmit = async () => {
		const trimmedName = name.trim()

		if (!trimmedName) {
			setError('Add a segment option name before saving.')
			return
		}

		setError('')
		setSaving(true)
		try {
			await onAdd({ name: trimmedName })
			toast.success({
				title: segment ? 'Segment option updated' : 'Segment option added',
				message: `${trimmedName} was saved successfully.`,
			})
		} catch (err) {
			console.error('Error saving segment option', err)
			setError(err.message || 'Failed to save segment option.')
		} finally {
			setSaving(false)
		}
	}

	return (
		<Modal
			opened={show}
			onClose={onClose}
			title={`${segment ? 'Edit' : 'Add'} Segment Option`}
			centered
		>
			<Stack spacing='md'>
				{error && (
					<Alert color='red' title='Segment option not saved'>
						{error}
					</Alert>
				)}

				<TextInput
					label='Name'
					value={name}
					error={error && !name.trim() ? 'Name is required.' : null}
					onChange={(event) => {
						setName(event.target.value)
						if (error) setError('')
					}}
				/>

				<Group position='right' spacing='sm'>
					<Button variant='default' onClick={onClose}>
						Cancel
					</Button>
					<Button onClick={handleSubmit} disabled={saving}>
						{saving ? 'Saving...' : segment ? 'Save Changes' : 'Add'}
					</Button>
				</Group>
			</Stack>
		</Modal>
	)
}

export default SegmentOptionModal
